var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75a3.59 3.59 0 0 0-2.575 1.092A3.79 3.79 0 0 0 8.35 7.5a3.79 3.79 0 0 0 1.075 2.658A3.59 3.59 0 0 0 12 11.25a3.59 3.59 0 0 0 2.575-1.092A3.79 3.79 0 0 0 15.65 7.5a3.79 3.79 0 0 0-1.075-2.658A3.59 3.59 0 0 0 12 3.75zM9.332 13.875c-1.478 0-2.443.444-3.142 1.159a4.016 4.016 0 0 0-1.14 2.816v1.462c0 .261.102.498.27.67a.88.88 0 0 0 .63.268h12.1a.88.88 0 0 0 .63-.269.953.953 0 0 0 .27-.669V17.85c0-1.1-.435-2.095-1.14-2.816a3.808 3.808 0 0 0-2.73-1.159c-1.234.36-2.133.563-3.08.563a6.62 6.62 0 0 1-2.668-.563z",
    stroke: "#8F9BB3",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7e9a7d0c.svg";
export { ForwardRef as ReactComponent };